const viewEventPush = {
  type: "event",
  eventType: "VIEW",
  pageVersion: 1,
};

// var RECOMMENDATION_FLAG = "yuspTest=1";
const RECOMMENDATION_FLAG = undefined;

const RESET_CSS_ID = "tbl-reco-box-css-reset";
const CSS_OVERRIDE_ID = "tbl-ecrec-css-override";
const TBL_ELEMENT_FOUND_DATA_ATTR = "data-tbl-element-found";
const MOBILE_MAX_WIDTH_THRESHOLD = 1024;
const PAGE_EVENT_ATTRIBUTE = "ECREC_PAGE";
const IS_ECREC = true;

let _CURRENT_PAGE_ITEMID = ""; // e.g.: 1561653_/example/path/here
let _CUSTOM_SCRIPT_AFTER = undefined;
let _CUSTOM_SCRIPT_BEFORE = undefined;
let _DISABLED_RECOMMENDATION_AFTER_SCRIPT = undefined;
let _CUSTOM_CAROUSEL = undefined;
let _CURRENT_PATH = window.location.pathname;
let _INIT_CALLBACK = undefined;
let _IS_MOBILE = undefined;
let _IS_NAVIGATION_WATCHER_SET = false;
let _PLACEMENT_WATCHER_ELEMENT_SELECTOR = undefined;
let _IMPRESSION_ID = undefined;
let _INTERVAL = undefined;
let _RECOMMENDATION_CONTAINER_LISTENER = false;
let _OVERRIDE_GET_ITEM_ID_FUNCTION = undefined;

const SHOW_RECOMMENDATION_OBVERVER_OPTIONS = {
  root: null,
  rootMargin: "0px",
  threshold: 0.6,
};
const visibilityObserver = new IntersectionObserver(visibilityCallback, SHOW_RECOMMENDATION_OBVERVER_OPTIONS);

function insertCSSReset() {
  const cssReset =
    ".reco_box,.reco_box *,.reco_box ::after,.reco_box ::before{box-sizing:border-box!important}.reco_box :where(:not(iframe,canvas,img,svg,video):not(svg *,symbol *)){all:unset;display:revert}.reco_box a,.reco_box button{cursor:revert}.reco_box menu,.reco_box ol,.reco_box ul{list-style:none}.reco_box img{max-width:100%}.reco_box table{border-collapse:collapse}.reco_box textarea{white-space:revert}.reco_box meter{-webkit-appearance:revert;appearance:revert}.reco_box ::placeholder{all:unset}.reco_box :where([hidden]){display:none}.reco_box :where([contenteditable]){-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;line-break:after-white-space;-webkit-line-break:after-white-space}.reco_box :where([draggable=true]){-webkit-user-drag:element}";
  insertCSS(RESET_CSS_ID, cssReset);
}

function getLocationString() {
  const canonicalLink = document.querySelector('link[rel="canonical"]');

  if (canonicalLink !== null) {
    const url = new URL(canonicalLink.href);
    return url.hostname + url.pathname;
  } else {
    return window.location.hostname + window.location.pathname;
  }
}

function insertCSS(id, css) {
  let style = document.createElement("style");
  style.id = id;
  style.textContent = css;

  document.head.appendChild(style);
}

function isMobileAgent() {
  if (!navigator || !navigator.userAgent) _IS_MOBILE = false;
  _IS_MOBILE =
    window.innerWidth <= MOBILE_MAX_WIDTH_THRESHOLD &&
    (navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i));

  return _IS_MOBILE;
}

function setupGravity(publisherId, gravity) {
  const currentTitle = document.title;
  (function setGacid() {
    let gacid = "-";

    try {
      gacid = (function getGACookie() {
        let value = "; " + document.cookie;
        let parts = value.split("; _ga=");
        if (parts.length === 2) {
          let gt = parts.pop().split(";").shift();
          let ps = gt.split(".");
          return ps[ps.length - 2] + "." + ps[ps.length - 1];
        }
      })();
    } catch (e) {
      console.log(e);
    }

    gravity.push({
      type: "set",
      gacid: gacid,
    });
  })();

  gravity.push({
    type: "set",
    itemId: _CURRENT_PAGE_ITEMID,
  });

  gravity.push({
    type: "set",
    advertiser: publisherId,
  });

  gravity.push({
    type: "set",
    title: currentTitle,
  });

  gravity.push({
    type: "set",
    useragent: window.navigator.userAgent,
  });

  _IMPRESSION_ID = getImpressionId();

  gravity.push({
    type: "set",
    overwrite: true,
    slImpressionId: _IMPRESSION_ID,
  });

  gravity.push({
    type: "set",
    page: PAGE_EVENT_ATTRIBUTE,
  });

  gravity.push({
    type: "set",
    isECREC: IS_ECREC,
  });

  if (_CURRENT_PAGE_ITEMID) {
    const event = Object.assign(
      {
        itemId: _CURRENT_PAGE_ITEMID,
      },
      viewEventPush
    );

    gravity.push(event);
  }
}

function getRecommendationRequests(placementData, gravity) {
  const errorStack = [];
  const requests = [];

  try {
    placementData.forEach(function (data) {
      let req = generateRequest.apply(null, data);
      // Normalize the request looking for errors
      if (req) {
        if (typeof req === "string") {
          errorStack.push(req);

          gravity.push({
            type: "event",
            eventType: "ERROR",
            itemId: _CURRENT_PAGE_ITEMID,
            errorMsg: req,
          });
        } else {
          requests.push(req);
        }
      }
    });
  } catch (e) {
    gravity.push({
      type: "event",
      eventType: "ERROR",
      itemId: _CURRENT_PAGE_ITEMID,
      errorMsg: e,
    });
  }

  // Reorder groupSize and groupSeq if there are any errors
  if (errorStack.length > 0 && placementData.length > 1) {
    requests.forEach(function (req, index) {
      req.groupSize = requests.length;
      req.groupSeq = index + 1;
    });
  }

  requests.forEach(function (req) {
    // let template = req.templating.template;
    // const isCarousel = template.includes('data-is-carousel="true"') || str.includes("data-is-carousel='true'");

    // if (!!isCarousel) template = template.replace('loading="lazy"', '');

    req.currentItemId = _CURRENT_PAGE_ITEMID;
    gravity.push(req);
  });
}

function generateRequest(
  containerSelector,
  targetPosition,
  placementId,
  scenarioId,
  resultNames,
  numberLimit,
  template,
  groupSize,
  groupSeq,
  groupId,
  elementToHide
) {
  const container = document.querySelector(containerSelector);
  const additional_result_names = [];
  let targetDiv = document.createElement("div");

  if (container == null) return "Cannot render request, missing item with selector: " + containerSelector;

  targetDiv.setAttribute("id", placementId);
  targetDiv.className = "reco_box";

  if (
    targetPosition !== "beforebegin" &&
    targetPosition !== "afterbegin" &&
    targetPosition !== "beforeend" &&
    targetPosition !== "afterend"
  ) {
    targetPosition = "beforeend";
  }

  container.insertAdjacentElement(targetPosition, targetDiv);

  let rec = {
    type: "recommendation",
    scenarioId: scenarioId,
    resultNames: resultNames.concat(additional_result_names),
    numberLimit: numberLimit,
    dataModifier: dataModifier,
    itemId: _CURRENT_PAGE_ITEMID ? _CURRENT_PAGE_ITEMID : "",
    selector: containerSelector,
    callback: recommendationCallback,
    templating: {
      targetElementId: placementId,
    },
    elementToHide: elementToHide,
  };

  if (groupSize > 1) {
    rec.groupSize = groupSize;
    rec.groupSeq = groupSeq;
    rec.groupId = groupId;
  }

  if (template) {
    rec.templating.template = template;
  }

  return rec;
}

function handleRecClickEvent(event) {
  event.stopPropagation();

  let target = event.target;
  let cardItemId = null;

  do {
    cardItemId = target.getAttribute("data-yuspitemid");
    target = target.parentElement;
  } while (!cardItemId && target != null);

  if (cardItemId) {
    const gravity = window._gravity || [];

    gravity.push({
      type: "event",
      eventType: "REC_CLICK",
      recId: target.closest(".reco_box").getAttribute("data-yusp-recid"),
      itemId: cardItemId,
      currentPageItemId: _CURRENT_PAGE_ITEMID,
    });
  }
}

function visibilityCallback(entries, observer) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      const item = entry.target;
      const recId = item.closest(".reco_box").getAttribute("data-yusp-recid");
      const cardItemId = item.getAttribute("data-yuspitemid");
      const imageItem = item.querySelector('img');
      const nextSibling = item.nextElementSibling;
      const previousSibling = item.previousElementSibling;
      let nextSiblingImg = null;
      let previousSiblingImg = null;

      if (imageItem) {
        const imageSrc = imageItem.dataset.src;
        if (imageSrc) imageItem.src = imageSrc;

        if (nextSibling && nextSibling.getAttribute("data-yuspitemid")) {
          nextSiblingImg = nextSibling.querySelector('img');
          if (nextSiblingImg && nextSiblingImg.classList.contains("lazy")) {
            const siblingSrc = nextSiblingImg.dataset.src;
            if (siblingSrc) nextSiblingImg.src = siblingSrc;
          }
        }

        if (previousSibling && previousSibling.getAttribute("data-yuspitemid")) {
          previousSiblingImg = previousSibling.querySelector('img');
          if (previousSiblingImg && previousSiblingImg.classList.contains("lazy")) {
            const siblingSrc = previousSiblingImg.dataset.src;
            if (siblingSrc) previousSiblingImg.src = siblingSrc;
          }
        }
      }

      imageItem?.classList.remove("lazy");
      nextSiblingImg?.classList.remove("lazy");
      previousSiblingImg?.classList.remove("lazy");

      const gravity = window._gravity || [];

      gravity.push({
        type: "event",
        eventType: "SHOW_RECOMMENDATION",
        recId: recId,
        itemId: cardItemId,
        currentPageItemId: _CURRENT_PAGE_ITEMID,
      });

      visibilityObserver.unobserve(item);
    }
  });
}

function recommendationCallback(data1, data2) {
  const tempRecId = data1.recommendationId;
  const tempTargetElementId = data2.targetElementId;

  let element = document.getElementById(tempTargetElementId);
  element.setAttribute("data-yusp-recid", tempRecId);

  let carouselElement = element.querySelector("[data-is-carousel]");
  let items = element.querySelectorAll("[data-yuspitemid]");
  items = Array.prototype.slice.call(items);

  items.forEach(function (item) {
    visibilityObserver.observe(item);
  });

  if (_IS_MOBILE && !!carouselElement) {
    element.classList.add("is-mobile");
  }

  if (typeof _CUSTOM_CAROUSEL === "function") _CUSTOM_CAROUSEL(carouselElement, data1.items.length);
  if (typeof _CUSTOM_SCRIPT_AFTER === "function") _CUSTOM_SCRIPT_AFTER(items);
}

function dataModifier(data, elementToHide) {
  if (elementToHide && data && data.items && data.items.length > 0) {
    var targetElementsToHide = document.querySelectorAll(elementToHide);

    if (targetElementsToHide.length > 0) {
      [].slice.call(targetElementsToHide).forEach(function (el) {
        el.style.display = "none";
        el.style.visibility = "hidden";
        el.setAttribute("aria-hidden", true);
      });
    }
  }

  let mProducts = data.products;
  let mRecommendationId = data.recommendationId;

  if (!mProducts && !mRecommendationId) return data;

  for (let i = 0; i < mProducts.length; i++) {
    const productData = mProducts[i];

    if (productData.hasOwnProperty("url")) {
      let newUrl = productData.url + "?utm_source=gravity&utm_medium=" + productData.predAB + "&utm_content=" + mRecommendationId;

      if (RECOMMENDATION_FLAG) {
        newUrl += "&" + RECOMMENDATION_FLAG;
      }

      productData.url = newUrl;
      productData.url_list = [newUrl];
    }
  }

  return data;
}

function checkDocumentReady() {
  if (_INTERVAL) clearInterval(_INTERVAL);

  _INTERVAL = setInterval(function () {
    _RECOMMENDATION_CONTAINER_LISTENER = true;

    const element = document.querySelector(_PLACEMENT_WATCHER_ELEMENT_SELECTOR + ":not([" + TBL_ELEMENT_FOUND_DATA_ATTR + "])");

    if (element && element !== null) {
      clearInterval(_INTERVAL);
      _RECOMMENDATION_CONTAINER_LISTENER = false;

      element.setAttribute(TBL_ELEMENT_FOUND_DATA_ATTR, true);
      window.dispatchEvent(new Event("recommendationPlacementFound"));
    }
  }, 200);

  setTimeout(function () {
    if (_INTERVAL) {
      clearInterval(_INTERVAL);
      _RECOMMENDATION_CONTAINER_LISTENER = false;
    }
  }, 10000);
}

function listenToURLChanges() {
  const { pushState, replaceState } = history;

  history.pushState = function (...args) {
    const result = pushState.apply(this, args);
    window.dispatchEvent(new Event("fallbackLocationChange"));
    return result;
  };

  history.replaceState = function (...args) {
    const result = replaceState.apply(this, args);
    window.dispatchEvent(new Event("fallbackLocationChange"));
    return result;
  };

  window.addEventListener("popstate", () => {
    window.dispatchEvent(new Event("fallbackLocationChange"));
  });

  window.addEventListener("fallbackLocationChange", function () {
    if (_CURRENT_PATH !== window.location.pathname) {
      hideExistingRecommendations();
      setTimeout(_INIT_CALLBACK, 0);
    }
  });
}

function watchNavigation() {
  if (window.navigation) {
    window.navigation.addEventListener("navigatesuccess", function () {
      if (_CURRENT_PATH !== window.location.pathname) {
        hideExistingRecommendations();
        setTimeout(_INIT_CALLBACK, 0);
      }
    });
  } else {
    listenToURLChanges();
  }

  _IS_NAVIGATION_WATCHER_SET = true;
}

function hideExistingRecommendations() {
  const cssOverride = document.getElementById(CSS_OVERRIDE_ID);
  if (cssOverride) {
    cssOverride.remove();
  }

  let earlierRecommendations = document.querySelectorAll(".reco_box[data-yusp-recid]");
  earlierRecommendations = Array.prototype.slice.call(earlierRecommendations);

  if (earlierRecommendations.length > 0) {
    earlierRecommendations.forEach(function (rec) {
      rec.remove();
    });
  }
}

export function getCurrentPageItemId() {
  return _CURRENT_PAGE_ITEMID;
}

export function getImpressionId() {
  return window.__SKIM_JS_BTN_WIDGET__ && window.__SKIM_JS_BTN_WIDGET__.impression_id;
}

export async function hashString(input, algo = "SHA-1", stringLength = 8) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const digest = await crypto.subtle.digest(algo , data);
  const hexString = Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
  return hexString.substring(0, stringLength);
}

/**
    @param {function Boolean} isRecommendationEnabled - Function that returns a boolean value whether the recommendation should be enabled or not
    @param {string} PUBLISHER_ID - Prefix for itemIds and value for Advertiser ID
    @param {Array} PLACEMENT_DATA - Recommendation details
    @param {string} initCallback - Function for intialization in case of navigation with SPA
    @param {string} CSS_OVERRIDE - CSS for adjustemnts on Publisher page elements
    @param {boolean} isInsertCSSReset - whether to insert CSS reset for recommendation box, default is true
    @param {customCarousel} function - unique full functionality for carousel
    @param {customScriptAfter} function - customScript at the after recommendation
    @param {customScriptBefore} function - customScript at the beginning of the init function
    @param {disabledRecommendationAfterScript} function - customScript for disabled recommendation
    @param {overrideGetItemIdFunction} function - script for overriding getItemId
*/
export function init(
  isRecommendationEnabled,
  PUBLISHER_ID,
  PLACEMENT_DATA,
  initCallback,
  CSS_OVERRIDE,
  isInsertCSSReset,
  customCarousel,
  customScriptAfter,
  customScriptBefore,
  disabledRecommendationAfterScript,
  overrideGetItemIdFunction
) {
  _PLACEMENT_WATCHER_ELEMENT_SELECTOR = PLACEMENT_DATA[0][0];
  _INIT_CALLBACK = initCallback;
  _CUSTOM_CAROUSEL = customCarousel;
  _CUSTOM_SCRIPT_AFTER = customScriptAfter;
  _CUSTOM_SCRIPT_BEFORE = customScriptBefore;
  _DISABLED_RECOMMENDATION_AFTER_SCRIPT = disabledRecommendationAfterScript;
  _CURRENT_PATH = window.location.pathname;
  _OVERRIDE_GET_ITEM_ID_FUNCTION = overrideGetItemIdFunction;

  const gravity = window._gravity || [];

  const getItemIdToUse = typeof _OVERRIDE_GET_ITEM_ID_FUNCTION === "function" ? _OVERRIDE_GET_ITEM_ID_FUNCTION : getItemId;

  getItemIdToUse(PUBLISHER_ID).then((itemId) => {
    _CURRENT_PAGE_ITEMID = itemId;
    setupGravity(PUBLISHER_ID, gravity);

    if (!_RECOMMENDATION_CONTAINER_LISTENER) {
      checkDocumentReady();
    }
  });

  const recommendationContainerEventListener = function (event) {
    event.stopImmediatePropagation();

    if (isRecommendationEnabled()) {
      if (!document.getElementById(RESET_CSS_ID) && isInsertCSSReset !== false) {
        insertCSSReset();
      }

      if (CSS_OVERRIDE && !document.getElementById(CSS_OVERRIDE_ID)) {
        insertCSS(CSS_OVERRIDE_ID, CSS_OVERRIDE);
      }

      isMobileAgent();

      try {
        if (typeof _CUSTOM_SCRIPT_BEFORE === "function") _CUSTOM_SCRIPT_BEFORE();
        getRecommendationRequests(PLACEMENT_DATA, gravity);
      } catch (e) {
        console.log("Ecrec recommendation cannot be sent: ", e);

        gravity.push({
          type: "event",
          eventType: "ERROR",
          path: locationString ? locationString : window.location.href,
          errorMsg: e,
        });
      }

      document.addEventListener("click", handleRecClickEvent);
    } else if (typeof _DISABLED_RECOMMENDATION_AFTER_SCRIPT === "function") {
      _DISABLED_RECOMMENDATION_AFTER_SCRIPT();
    }
  };

  window.removeEventListener("recommendationPlacementFound", recommendationContainerEventListener);
  window.addEventListener("recommendationPlacementFound", recommendationContainerEventListener, { once: true });

  if (!_IS_NAVIGATION_WATCHER_SET) {
    watchNavigation();
  }
}

export const getItemId = (() => {
  let hash = null;
  const locationString = getLocationString();
  return async (prefix) => {
    if (!hash) {
      hash = await hashString(locationString);
    }
    return prefix ? `${prefix}_${hash}_${locationString}` : `${hash}_${locationString}`;
  }
})();
